// src/components/StartQuizModal/index.js
import StartQuizModal from './StartQuizModal';
export default StartQuizModal;